import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class BankProxy extends ProxyBase {
  postCapitalAdequacy(params) {
    return this.post('CapitalAdequacy', params)
  }
  downloadCapitalAdequacy(params) {
    return this.post('CapitalAdequacy/Export', params, {}, 'download')
  }
  postAssetQuality(params) {
    return this.post('AssetQuality', params)
  }
  downloadAssetQuality(params) {
    return this.post('AssetQuality/Export', params, {}, 'download')
  }
  postEarningQuality(params) {
    return this.post('EarningQuality', params)
  }
  downloadEarningQuality(params) {
    return this.post('EarningQuality/Export', params, {}, 'download')
  }
  postLiquidity(params) {
    return this.post('Liquidity', params)
  }
  downloadLiquidity(params) {
    return this.post('Liquidity/Export', params, {}, 'download')
  }
  postBusinessGrowth(params) {
    return this.post('BusinessGrowth', params)
  }
  downloadBusinessGrowth(params) {
    return this.post('BusinessGrowth/Export', params, {}, 'download')
  }
}

export default new BankProxy('IndustryAnalysis/')
